$(document).ready(function() {
  $('.menu-tab').on('click', function(e){
    $('.active').each((_, el) => {
      el.classList.remove('active');
    })
    $('.show').each((_, el) => {
      el.classList.remove('show');
    })
    let selectedBlock= $($(e.target).parent().data('target'))
    $(this).addClass('active')
    selectedBlock.addClass('active')
    selectedBlock.addClass('show')
    $('#careHomeImages').addClass('active')
    $(e.target).parent().addClass('active')
  })

  $('#careImageCarouselControls').on('slid.bs.carousel', function () {
    let currentSlideIndex = $(this).find('.active').index()
    $('.careImageCaption').css('display', 'none')
    $(`#careImageCaption${currentSlideIndex}`).css('display', 'block')
  })

  $('.pamphlet-field').on('cocoon:after-insert', function(e, item){
    let order = $('.nested-fields').index(item)
    $('.order_form').eq(order).val(order + 1)
  })
})

$(document).on('change', '.custom-file-input', function(){
  if($(this)[0].files[0] == undefined){
    $(this).next('.custom-file-label').html('パンフレットを選択')
  }else{
    $(this).next('.custom-file-label').html($(this)[0].files[0].name)
  }
})



